import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { AdyenAccountHoldersList } from "./components/AdyenAccountHoldersList";
import { Outlet } from "react-router-dom";
import { useGetAdyenAccountHolders } from "./service/adyen-account-holders-api";
import { SpinnerBlock } from "../common/Spinner";

export const AdyenAccountHoldersPage = () => {
  const {
    data: accountHolders,
    isLoading: isLoadingAccountHolders,
  } = useGetAdyenAccountHolders();

  return (
    <>
      {isLoadingAccountHolders || !accountHolders ? (
        <SpinnerBlock />
      ) : (
        <>
          <PageWrapper>
            <AdyenAccountHoldersList accountHolders={accountHolders} />
          </PageWrapper>
          <Outlet />
        </>
      )}
    </>
  );
};
